/**
 * Menu View
 */

define(function(require, exports, module) {
    'use strict';
    var user = require('user');
    var MenuView = require('modules/menu/menu.view');

    require('widgets/accordion.widget');

    module.exports = MenuView.extend({
        _renderSideMenu: function() {
            if (this.slideMenuWcId) {
                this.$el.find('.fn-common-slide-menu').remove();

                return;
            }

            this.$el.html(this.tmpl('side.menu', {
                menuItems: this.menuItems,
                isUserLogged: user.isLoggedIn(),
                userName: user.get('userName')
            }).replace());

            this.wrap = this.$('.fn-menu-wrap')[0];
            this.list = this.$('.fn-menu-list')[0];
        },
    });
});
